import * as React from 'react';
import { generateCommentBookingStateEvent, IBookingStateEvent } from '../../../data/entities/booking-state';
import { DateFormats, getFullDateLocalTimeZone } from '../date-picker/helpers';
import { Content } from '../page';
import { Table, Tbody, Td, Th, Thead, Tr } from '../table';

interface IBookingStateEventsProps {
	bookingStateEvents: IBookingStateEvent[];
}

export const BookingStateEvents: React.FC<IBookingStateEventsProps> = ({ bookingStateEvents }) => {
	bookingStateEvents.sort((a, b) => (a.id && b.id && (a.id < b.id)) || (a.created_at < b.created_at) ? 1 : -1);
	return (
		<Content type="full">
			<div className="booking-payment__header">
				<div className="booking-payment__title"><h2>Booking State Events</h2></div>
			</div>

			<Table className="booking-payment-internal">
				<Thead>
					<Tr>
						<Th>Date</Th>
						<Th>Details</Th>
					</Tr>
				</Thead>

				<Tbody>
					{bookingStateEvents.map((bookingEvent) =>
						<Tr>
							<Td>{getFullDateLocalTimeZone(new Date(bookingEvent.created_at), DateFormats.DayMonthYearTime)}</Td>
							<Td>{generateCommentBookingStateEvent(bookingEvent)}</Td>
						</Tr>
					)}
				</Tbody>
			</Table>
		</Content>
	);
};
